module.exports = __webpack_public_path__ + "static/beer-layer-4f01a6e903739f072b2bb0bdcff512b4.png";